module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-none element-with-heading",
    attrs: {
      "id": "uncategorized"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-with-image",
    attrs: {
      "id": "uncategorized-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Blurb")])])]), _vm._v(" "), _c('div', {
    staticClass: "heading-image-block heading-image-aspect-square heading-image-block-after-title-and-subtitle"
  }, [_c('div', {
    staticClass: "heading-image-size-container heading-image-width-250"
  }, [_c('img', {
    staticClass: "heading-image-image",
    attrs: {
      "alt": "",
      "src": "images/blue-watercolor-flower.jpg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "uncategorized-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("She might have refused the call to be a hero, but fate has other intentions.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-left"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Betrayed, Sif awakens from her artificial sleep to a new world where the Dark Elves have invaded and began to cull humanity. But it’s Loki, the Norse god of mischief, who has her head swimming. He’s given her one task—to fix this mess.")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Lady Hel has returned to Helheim, her kingdom restored, but it’s not enough. She’s dragged Thor with her to teach him a valuable lesson, and with the Bifrost Bridge broken, the gods of Asgard are unable to help.")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("The only hope this dystopian Midgard has is a motley crew, and should they fail, they risk the Dark Elves culling them, and all of humanity.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c9c75d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blurb.vue
// module id = 69
// module chunks = 0